<template>
  <div class="staffHistory">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <van-tabs v-model="activeName" @click="onTabClick">
      <van-tab
        v-for="(v, i) in tabList"
        :key="i"
        :title="v.tabTitle"
        :name="v.tabName"
      >
        <div v-if="v.tabName === 'checkRecord'" class="de mt10 mr20 mb10">
          <svg-icon v-if="!isHistory" icon-class="history" @click="onHistory" />
          <svg-icon v-else icon-class="back" @click="onHistory" />
        </div>
        <div v-if="v.tabName === 'checkRecord'">
          <history-record
            v-if="isHistory"
            key="1"
            active-name="history"
            @openQrcode="openQrcode"
            @openInviteCode="openInviteCode"
          />
          <history-record
            v-else
            key="2"
            :active-name="v.tabName"
            @openQrcode="openQrcode"
            @openInviteCode="openInviteCode"
          />
        </div>
        <history-record
          v-else
          :active-name="v.tabName"
          @openQrcode="openQrcode"
          @openInviteCode="openInviteCode"
        />
      </van-tab>
    </van-tabs>

    <van-dialog
      v-model="showQrCodeDialog"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      title="请扫描下方二维码即可通行"
      class="bigHeight"
    >
      <div id="qrcode" ref="qrcode" class="qrcode">
        <img :src="qrCodeImgUrl" alt="" mode="widthFix" />
      </div>
      <van-button
        icon="replay"
        type="info"
        @click="refreshQrcode"
      >刷新</van-button>
      <div class="tips">
        <p>温馨提示</p>
        <p>1、该二维码仅限来访当天一次进出有效</p>
        <p>2、动态二维码仅限个人使用，3分钟有效，超时后刷新即可使用</p>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showInviteCodeDialog"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
      title="邀请码"
      class="bigHeight"
    >
      <p class="diaCode">{{ inviteCode }}</p>
      <div class="tips">
        <p>温馨提示</p>
        <p>1、邀请码仅来访当天有效，请勿泄露</p>
        <p>2、来访请先到前台出示身份证及邀请码验证身份</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import config from '@/common/config';
import { GetStaffAppointDetail } from '@/api/user';
import historyRecord from './historyRecord';
export default {
  name: 'StaffHistory',
  components: {
    historyRecord
  },
  data() {
    return {
      baseURL:
        process.env.NODE_ENV === 'development'
          ? config.baseUrl.dev
          : config.baseUrl.pro,
      isHistory: false,
      showQrCodeDialog: false,
      showInviteCodeDialog: false,
      inviteCode: '', // 邀请码
      hisId: '', // 历史记录id
      tabList: [
        {
          tabTitle: '我的审核',
          tabName: 'checkRecord'
        },
        {
          tabTitle: '我的访客',
          tabName: 'inviteReord'
        },
        {
          tabTitle: '我的预约',
          tabName: 'appointment'
        }
      ],
      subHead: '历史记录',
      activeName: 'checkRecord',
      size: 10,
      visiDate: '',
      nowStatus: '', // 状态。从消息进来根据状态判断是二维码还是详情
      qrcode: '', // 因为路由参数的qrcode带#h号，被干掉了，所以从详情拿qrcode
      historyDetail: {},
      timestamp: new Date().getTime(),
      qrCodeImgUrl: ''
    };
  },
  watch: {
    historyDetail: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          if (this.nowStatus === 'WAITING_VISIT') {
            this.showQrCodeDialog = true;
            this.$nextTick(() => {
              this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(this.qrcode)}&timestamp=${this.timestamp}`;
            });
          } else {
            this.$router.push({
              name: 'historyDetail',
              query: { id: this.hisId, activeName: 'appointment' }
            });
          }
        });
      }
    }
  },
  created() {
    // 从消息模板进来
    if (this.$route.query.qrcode && this.$route.path === '/staffHistory') {
      this.activeName = 'appointment';
      this.hisId = this.$route.query.id;
      this.getStaffAppointDetail(this.hisId);
    }

    if (this.$route.query.askCode && this.$route.path === '/staffHistory') {
      this.activeName = 'appointment';
      // 并展示邀约码
      this.showInviteCodeDialog = true;
      this.inviteCode = this.$route.query.askCode;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'appointmentSuc') {
        vm.activeName = 'appointment';
      }
      // else {
      //   vm.activeName = from.query.activeName || 'checkRecord';
      // }
    });
  },
  methods: {

    // 员工预约记录详情
    getStaffAppointDetail(id) {
      const data = {
        id: id
      };
      GetStaffAppointDetail(data).then(response => {
        this.historyDetail = response.data;
        this.nowStatus = this.historyDetail.visitorStatus;
        this.qrcode = this.historyDetail.qrCode;
      });
    },
    openQrcode(id, qrcode) {
      this.qrcode = qrcode;
      this.showQrCodeDialog = true;
      this.hisId = id;
      this.$nextTick(() => {
        this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(qrcode)}&timestamp=${this.timestamp}`;
      });
    },
    refreshQrcode() {
      this.timestamp = (new Date()).getTime();
      this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(this.qrcode)}&timestamp=${this.timestamp}`;
    },
    openInviteCode(id, askCode) {
      this.showInviteCodeDialog = true;
      this.inviteCode = askCode;
    },
    goBack() {
      // this.$router.go(-1)
      this.$store.dispatch('clearIncludeName');
      this.$router.push({ name: 'user' });
    },
    // 点击tab切换
    onTabClick(name) {},
    onHistory() {
      this.isHistory = !this.isHistory;
    }
  }
};
</script>

<style lang="less" scoped>
.staffHistory {
  /deep/.van-tabs,
  .van-tabs__wrap {
    height: 0.47rem;
    .van-tabs__nav {
      background: rgba(250, 250, 250, 1);
    }
    .van-tabs__nav--line {
      color: #3b86ff;
    }
    .van-tab {
      color: #333;
    }
    .van-tab--active {
      color: #3b86ff;
    }
    .van-tabs__line {
      background-color: #3b86ff;
    }
  }
  .qrcode {
    // width: 1.64rem;
    // height: 1.64rem;
    // margin: 0 auto;
    text-align: center;
    /deep/img {
      width: 100%;
      height: 100%;
      // height: 1.64rem;
    }
  }
  .diaCode {
    color: #333;
    text-align: center;
    font-size: 0.3rem;
    line-height: 0.3rem;
    height: 0.3rem;
    margin-bottom: 0.2rem;
  }
  .van-button {
    display: flex;
    width: 0.95rem;
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center;
    margin: 0.25rem auto;
  }
  .tips {
    font-size: 0.12rem;
    color: #ffbe00;
    line-height: 0.18rem;
  }
}
</style>
